import React from 'react';
import "../../assets/style/Apropos.css";
import {
    FaAward,
    FaHeadphones,
    FaFileDownload,
    FaSuitcase
} from 'react-icons/fa';
import cv from "../../assets/cv/CVRavaka.pdf";
import { useTranslation } from "react-i18next"
import background from "../../assets/video/me.mp4";
import ReactGA from 'react-ga4';

const Apropos: React.FC = () => {
    const { t } = useTranslation('fr', { useSuspense: false });
    return (
        <div>
            <section className="about section" id="about">
                <div className='contenu'>
                    <h2 data-heading="Mon Introduction" className="section__title">{t('about.about')}</h2>

                    <div className="about__container container grid">
                        <div className='about__image'>
                            <video className="video-background" autoPlay loop muted>
                                <source src={background} type="video/mp4" />
                            </video>
                        </div>


                        <div className="about__data">
                            <h3 className="about__heading">
                                {t('about.studentDescription')}
                            </h3>
                            <p className="about__description">
                                {t('about.schoolAndProgram')}
                            </p>

                            <p className="about__description">
                                {t('about.academicBackground')}
                            </p>
                            <div className="about__info grid">
                                <div className="about__box">
                                    <FaSuitcase className="about__icon" />
                                    <h3 className="about__title">{t('about.experienceTitle')}</h3>
                                    <span className="about__subtitle">{t('about.experienceSubtitle')}</span>
                                </div>

                                <div className="about__box">
                                    <FaAward className="about__icon" />

                                    <h3 className="about__title">{t('about.projectsTitle')}</h3>
                                    <span className="about__subtitle">{t('about.projectsSubtitle')}</span>
                                </div>

                                <div className="about__box">
                                    <FaHeadphones className="about__icon" />
                                    <h3 className="about__title">{t('about.supportTitle')}</h3>
                                    <span className="about__subtitle"> {t('about.supportSubtitle')} </span>
                                </div>
                            </div>
                            <a download="" href={cv} className="button" onClick={() => ReactGA.event({ category: 'CV', action: 'download' })}>
                                <FaFileDownload className="button__icon" />
                                {t('about.download')}
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Apropos;